// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// Models
//import { CustomerModel } from '../_models/customer.model';
import { map, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ExcelService } from './excel.service';
//import { ExcelService } from '../../../_base/crud/services/excel.service';

@Injectable()
export class CustomersService {
	constructor(
		private http: HttpClient,
		private excelService: ExcelService
	) { }

	// get customers
	findCustomers(customer): Observable<any> {
		//debugger
		return this.http.post(`${environment.endPoint}/CRM/Leads`, customer)
			.pipe(
				map(res => res)
			);
	}
	// /api/ReferralLead/GetAllLeadsByReferralUserId
	// add customer
	addCustomer(customer: any): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/AddLead`, customer);
	}

	// update customer
	updateCustomer(customer: any): Observable<any> {
		return this.http.post(`${environment.endPoint}/CRM/UpdateLead`, customer);
	}

	// get customer
	getCustomer(customerList: any): Observable<any> {
		const params = {
			'from': customerList.from,
			'to': customerList.to,
			'text': customerList.text || '',
			// 'referralUserIds': customerList.referralUserIds || null,
		}
		return this.http.post(`${environment.endPoint}/ReferralLead/Customers`, params);
	}

	//for rerral
	getreferralList(referralCode) {

		return this.http.get(`${environment.endPoint}/myreferral/GetReferralByReferralCode?referralCode=` + referralCode)
			.pipe(
				map(res => res)
			);
	}

	getReferralTimeLine(referredBy) {
		return this.http.get(`${environment.endPoint}/myreferral/GetTimelineByReferralCode?referredBy=` + referredBy)
			.pipe(
				map(res => res)
			);
	}

	getReferralCompanyDetail(customerId) {
		return this.http.get(`${environment.endPoint}/myreferral/GetCustomerById?customerId=` + customerId)
			.pipe(
				map(res => res)
			);
	}


	// My Team
	myTeam(): Observable<any> {
		const params =
		{
			'from': 1,
			'to': -1,
			'text': ''
		};
		return this.http.post(`${environment.endPoint}/CRM/MyTeam`, params)
			.pipe(map(res => res));
	}

	// file upload
	fileUpload(file: any): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/LeadsBulkUpload`, file);
	}

	// export to excel
	fileExport(customer,referBy): Observable<any> {
		const params = {
			'userId': 1,
			'search': customer.search || null,
			'from': customer.from,
			'to': customer.to,
			'fromDate': customer.fromDate || null,
			'toDate': customer.toDate || null,
			'ReferBy': referBy || null,
		}
		return this.http.post(`${environment.endPoint}/ReferralLead/Customers/Export`, params, { responseType: 'arraybuffer' })
		.pipe(
			map((res) => {
				return res;
			}),
			tap(
				data => {

					this.excelService.saveAsExcelFile(data, 'Referral')
				},
				error => console.log(error),
			),
			catchError(err => {
				return null;
			})
		);
	}

	// assign customer
	assignCustomer(customer): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/AssignLead`, customer)
	}

	// delete customer
	deleteCustomer(customerId: number): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/DeleteLead?leadId=` + customerId, { leadId: customerId });
	}

	// customer source
	getSource(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/LeadSource`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// customer stage
	getStage(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/LeadStage`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// customer type
	getType(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/LeadType`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// parent customer
	getParentCustomer(customerTypeId: number): Observable<any> {
		const params =
		{
			'from': 1,
			'to': -1,
			'LeadTypeId': customerTypeId
		};
		return this.http.post<any>(`${environment.endPoint}/CRM/LeadsByNextLeadType`, params)
			.pipe(map(resp => {
				return resp.data.Leads;
			}));
	}

	// territory
	getTerritory(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/Territories?from=1&text=&to=-1`)
			.pipe(map(resp => {
				return resp.data.Territory;
			}));
	}

	// customer tag
	getTag(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/Tags`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	//customer designation
	getDesignation(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/LeadDesignations`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// customer status
	getCustomerStatus(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/ReferralLead/Customer/Status`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// meeting objective / visit purpose
	getMeetingObjective(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}CRM/VisitPurposes`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// Referral objective
	getMyReferral(currentUser): Observable<any> {

		return this.http.get<any>(`${environment.endPoint}/GetReferralById?companyId=` + currentUser.CompanyDetail.CompanyId)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// customer action points
	getCustomerActionPoint(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/ActionPointsV1`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// custom Fields

	getCustomFields(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CustomFields`)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// add call log / meetingAnalysis
	addCallLog(callLog): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}CRM/MeetingAnalysis`, callLog);
	}

	// add opportunity
	addOpportunity(opportunity): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/Opportunity`, opportunity);
	}

	// add quick task
	addQuickTask(quickTask): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/MeetingAnalysis`, quickTask);
	}

	// add appointment
	addAppointment(appointment): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/CRM/AssignLeadRoster`, appointment);
	}

	// lead transactions
	customerTransaction(customer: any): Observable<any> {
		const params = {
			From: 0,
			FromDate: null,
			IsCheckIn: "",
			IsProductsAvailable: "",
			IsVisitForm: "",
			LeadId: customer.LeadId || null,
			OpportunityId: customer.OpportunityId !== undefined && customer.OpportunityId !== null ? customer.OpportunityId : null, // Ensuring null is explicitly passed
			StatusIds: customer.StatusIds || "",
			Text: customer.Text || "",
			To: 50,
			ToDate: null,
		};
	
		return this.http.post<any>(`${environment.endPoint}/ReferralLead/Customer/Transaction`, params)
			.pipe(map(resp => resp.data));
	}
	

	// comment customer transactions
	commentOnCustomerTransactions(comment): Observable<any> {
		return this.http.post<any>(`${environment.endPoint}/ReferralLead/Customer/CommentOnTransaction`, comment)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	// get email accounts
	getEmailAccounts(): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/EmailAccounts`)
			.pipe(map(resp => {
				return resp;
			}));
	}

	// get customer emails
	getCustomersEmails(customerId, nextPageToken): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/Leads/` + customerId + `/Emails?nextPageToken=` + nextPageToken)
			.pipe(map(resp => {
				return resp;
			}));
	}
	// getImages
	getImages(id): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/LeadTransactionImages?Id=` + id)
			.pipe(map(resp => {
				return resp;
			}));
	}

	//Visitform details
	getdetails(id: number): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/CRM/FormAnswer?leadTransactionId=` + id)
			.pipe(map(resp => {
				return resp;
			}));
	}
	bulkreport(loadtype: string, from: number, to: number, search: string): Observable<any> {
		const params =
		{
			'loadtype': loadtype,
			'from': from,
			'to': to,
			'text': search
		};
		return this.http.get<any>(`${environment.endPoint}/CRM/Customer/BulkUpload/ShowFile?loadtype=` + loadtype + '&from=' + from + '&text=' + search + '&to=' + to)
			.pipe(map(resp => {
				return resp;
			}));
	}
	exportReport(Id): Observable<any> {
		return this.http.post(`${environment.endPoint}/CRM/Customer/BulkUpload/ExportReport/` + Id, Id, { responseType: 'arraybuffer' })
			.pipe(
				map((res) => {
					return res;
				}),
				tap(
					//	data => this.excelService.saveAsExcelFile(data, 'Customers'),
					error => console.log(error),
				),
				catchError(err => {
					return null;
				})
			);
	}
	ViewReport(Id: number, from: number, to: number, search: string): Observable<any> {
		const params =
		{
			'Id': Id,
			'from': from,
			'to': to,
			'text': search
		};
		return this.http.get<any>(`${environment.endPoint}/CRM/Customer/BulkUpload/ViewReport?Id=` + Id + '&from=' + from + '&text=' + search + '&to=' + to)
			.pipe(map(resp => {
				return resp;
			}));
	}
	exportViewReport(Id): Observable<any> {
		return this.http.post(`${environment.endPoint}/CRM/Customer/BulkUpload/ExportViewReport/` + Id, Id, { responseType: 'arraybuffer' })
			.pipe(
				map((res) => {
					return res;
				}),
				tap(
					//	data => this.excelService.saveAsExcelFile(data, 'CustomersReport'),
					error => console.log(error),
				),
				catchError(err => {
					return null;
				})
			);
	}

	getCustomerDetails(customerId:number): Observable<any> {
		return this.http.get<any>(`${environment.endPoint}/ReferralLead/Customer/` + customerId)
			.pipe(map(resp => {
				return resp.data;
			}));
	}

	getVisitMetrics(leadId:any,isFinancialYear:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/VisitsMetrics/`+leadId+'?isFinancialYear='+isFinancialYear)
		.pipe(map(resp => {
			return resp;
		}));

	}
	getOpportunityMetrics(leadId:any,isFinancialYear:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/OpportunityMetrics/`+leadId+'?isFinancialYear='+isFinancialYear)
		.pipe(map(resp => {
			return resp;
		}));

	}

	getOrderMetrics(leadId:any,isFinancialYear:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/OrderMetrics/`+leadId+'?isFinancialYear=' + isFinancialYear)
		.pipe(map(resp => {
			return resp;
		}));
	}
	
	getMostOrderedProductsMetrics(leadId:any,isFinancialYear:any):Observable<any>{
	 	return this.http.get(`${environment.endPoint}/api/LeadsInsight/MostOrderProducts/`+leadId+'?isFinancialYear='+isFinancialYear)
		.pipe(map(resp => {
			return resp;
		}));
	}

	getReferralBusiness(leadId:any,isFinancialYear:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/ReferralBusiness/`+leadId+'?isFinancialYear='+isFinancialYear)
		.pipe(map(resp=>{
			return resp;
		}))
	}

	getVisitAndTaskMetrics(leadId:any,isFinancialYear:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/VisitFormsAndTaskMetrics/`+leadId+'?isFinancialYear='+isFinancialYear)
		.pipe(map(resp=>{
			return resp;
		}))
	}

	getCurrencySymbol(leadId:any):Observable<any>{
		return this.http.get(`${environment.endPoint}/api/LeadsInsight/Customer/Currency?leadId=`+leadId)
		.pipe(map(res =>{
			return res
		}))
	}

}
